import IUserData from 'types/sign-in/IUserData'

export default (user: IUserData) => {
  return (
    user &&
    (((user.ab375Compliant || user.gdprCompliant) && !!user.consent) || !(user.ab375Compliant || user.gdprCompliant))
  )
}
